import { useRoutes } from "react-router-dom";
import { getRouteDefinitions } from "./utilities/get-route-definitions";
import { useRoutingLocation } from "@coxauto-ui/cxm/routing";
import { useEffect } from "react";
import { getPageTitle } from "./utilities/get-page-title";

type RouteDefinition = {
  path: string;
  title?: string;
};

export interface SetPageTitlesProps {
  routes: RouteDefinition[];
  defaultTitle: string;
}

export function Routes() {
  const location = useRoutingLocation();

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);
  return useRoutes(getRouteDefinitions());
}

export default Routes;
